<ng-container *transloco="let t">
  @let examinationForms = examinationForms$ | async;
  @let shouldShowPane = shouldShowPane$ | async;

  @if (shouldShowPane || examinationForms?.hasError) {
    <article appearance="outline" class="gap-0! p-0! text-sm shadow-xs! 2xl:w-80" tuiCardLarge>
      @if (shouldShowPane) {
        @if (isMobile()) {
          <pxc-examination-mobile-pane />
        } @else {
          <pxc-examination-content />
        }
      } @else if (examinationForms?.hasError) {
        <tui-block-status size="m" [card]="true">
          <h4>{{ t('Une erreur est survenue lors du chargement des examens.') }}</h4>
          {{ examinationForms.error | error }}
        </tui-block-status>
      }
    </article>
  }
</ng-container>
